export default (props, vars) =>
  `${vars?.['uselookbook2']?.['lookbook']?.students?.length || 0} Students`;
